export const GRID_IDS = {
  // Routing Protocol grids
  ROUTING_PROTOCOL: 'ROUTING_PROTOCOL',
  ROUTING_PROTOCOL_GROUP: 'ROUTING_PROTOCOL_GROUP',
  ROUTING_PROTOCOL_STATION: 'ROUTING_PROTOCOL_STATION',
  ROUTING_PROTOCOL_STATION_POPUP: 'ROUTING_PROTOCOL_STATION_POPUP',
  ROUTING_PROTOCOL_EXCEPTION: 'ROUTING_PROTOCOL_EXCEPTION',
  JUNCTION_SYNONYM: 'JUNCTION_SYNONYM',

  // Rate Management grids
  PUBLICATIONS_LIST: 'PUBLICATIONS_LIST',
  PUBLICATION_DETAILS: 'PUBLICATION_DETAILS',
  ACTIVITY_LOG: 'ACTIVITY_LOG',
} as const;

export type GridId = (typeof GRID_IDS)[keyof typeof GRID_IDS];

export interface GridPreferences {
  applicationId: string;
  category: string;
  subCategory: string;
  preferenceCode: string;
  preferenceValue: PreferenceValue;
}

export interface PreferenceValue {
  data: GridConfig[];
}

export interface GridConfig {
  gridName: string;
  columns?: ColumnConfig[];
}

export interface ColumnConfig {
  field: string;
  visible: boolean;
  width?: number;
  sorting?: SortingConfig;
}

export interface SortingConfig {
  isSortable?: boolean;
  sortOrder?: string;
  sortIndex?: string;
}

export const GRID_PREFERENCE_CONFIG = {
  APPLICATION_ID: 'PRICING',
  CATEGORY: 'GRID_PREFERENCE',
  SUBCATEGORY: 'CUSTOM_GRID_TEMPLATE',
  PREFERENCE_CODE: 'TEMPLATE_LIST',
} as const;

export type GridPreferenceResponse = GridPreferences;
